import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

export function replaceNewlineWithBr(sentence: string) {
	const lines = sentence.split('\n');
	// 입력된 문자열을 개행 문자로 분할합니다.
	return lines
		.map(
			(line, index) =>
				`
			${line}
			${index !== lines.length - 1 ? '<br />' : ''}`,
		)
		.join('');
}

export function HTMLParse(content: string) {
	return parse(
		DOMPurify.sanitize(replaceNewlineWithBr(content), {
			ALLOWED_TAGS: ['strong', 'a', 'br', 'img', 'div', 'p'],
			ALLOWED_ATTR: ['href', 'target', 'rel', 'width', 'height', 'alt', 'src', 'align'],
		}),
	);
}
